import { render, staticRenderFns } from "./svgAppstore.vue?vue&type=template&id=be304316"
import script from "./svgAppstore.vue?vue&type=script&lang=js"
export * from "./svgAppstore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports